import { CoffeeIcon, GemIcon, UtensilsIcon } from 'lucide-react'
import { images } from './images'

export const mainNav = [
  { to: '/collectie/voor-haar', label: 'Voor haar' },
  { to: '/collectie/voor-hem', label: 'Voor hem' },
  { to: '/collectie/bestsellers', label: 'Bestsellers' },
  { to: '/collectie/nieuw', label: 'Nieuw' },
  { to: '/collectie/cadeaus', label: 'Cadeaus' },
  { to: '/collectie/alles', label: 'Alle producten' },
]

export const usps = [
  'Vóór 22:00 besteld, morgen in huis',
  'Gratis verzending vanaf € 50',
  '30 dagen bedenktijd',
]

export const categoryCircles = [
  { to: '/collectie/voor-haar', label: 'Voor haar', image: images.her },
  { to: '/collectie/voor-hem', label: 'Voor hem', image: images.him },
  { to: '/collectie/bestsellers', label: 'Bestsellers', image: images.argan },
  { to: '/collectie/sets', label: 'Hammam sets', image: images.giftset },
  { to: '/collectie/olien', label: 'Oliën', image: images.cactus },
  { to: '/collectie/geur', label: 'Geur', image: images.oud },
  { to: '/collectie/cadeaus', label: 'Cadeaus', image: images.geurset },
  { to: '/living', label: 'AMIRA Living', image: images.teaGlasses },
]

export const editorialDuo = [
  {
    to: '/collectie/voor-haar',
    title: 'Voor haar',
    text: 'Henna, arganolie en rozenwater — de rituelen van onze moeders.',
    image: images.her,
    alt: 'Handen met henna gieten arganolie in de handpalm',
  },
  {
    to: '/collectie/voor-hem',
    title: 'Voor hem',
    text: 'Savon Beldi, kessa en oud. Hammam-verzorging zonder poespas.',
    image: images.him,
    alt: 'Handen met een kessa boven een koperen kom in de hammam',
  },
]

export const livingNav = [
  { to: '/living/collectie/sieraden', label: 'Sieraden' },
  { to: '/living/collectie/servies', label: 'Borden & schalen' },
  { to: '/living/collectie/glazen', label: 'Glazen & kopjes' },
  { to: '/living/collectie/thee', label: 'Thee' },
  { to: '/living/collectie/decoratie', label: 'Decoratie' },
  { to: '/living/collectie/cadeaus', label: 'Cadeaus' },
  { to: '/living/collectie/alles', label: 'Alle producten' },
]

export const livingUsps = ['Handgemaakt in Marokko', 'Vóór 22:00 besteld, morgen in huis', 'Gratis verzending vanaf € 50']

export const livingQuickLinks = [
  { to: '/living/collectie/sieraden', title: 'Sieraden', text: 'Berber zilver & khamsa', icon: GemIcon },
  { to: '/living/collectie/servies', title: 'Borden & schalen', text: 'Handbeschilderd in Safi', icon: UtensilsIcon },
  { to: '/living/collectie/glazen', title: 'Thee & glazen', text: 'Beldi-glazen & theepotten', icon: CoffeeIcon },
]

export const livingCraftFacts = [
  { title: 'Servies', text: 'Handbeschilderd in de pottenbakkerijen van Safi en Fès.' },
  { title: 'Sieraden', text: 'Berber zilverwerk, gegraveerd in de Anti-Atlas.' },
  { title: 'Glas', text: 'Mondgeblazen beldi-glas uit Marrakech, van gerecycled glas.' },
]

export const cultureSteps = [
  { title: 'Geoogst in de Souss-vallei', text: 'De arganboom groeit alleen in het zuidwesten van Marokko. Daar, rond Aït Baha, begint elk flesje.' },
  { title: 'Met de hand verwerkt', text: 'Arganpitten worden traditioneel met de hand gekraakt door vrouwencoöperaties — vakmanschap dat van moeder op dochter gaat.' },
  { title: 'Puur gebotteld', text: 'Geen parfum, geen vulmiddelen. Alleen wat erin hoort, met een eerlijk etiket.' },
]
